import { useCrumbs } from "@/components/layout/CrumbsContext";
import { RunProgressView } from "@/components/plan-audit/RunProgressView";
import { ScorecardView } from "@/components/plan-audit/ScorecardView";
import { Skeleton } from "@/components/ui/skeleton";
import { useRun } from "@/hooks/use-plan-audit";

/**
 * One run.
 *
 * Which face it shows follows the run's own status rather than the URL: a run
 * still executing has no scorecard to show, and a finished one has no progress
 * left to report. Routing them to separate URLs would mean a link going stale
 * the moment the run finished.
 */
export function RunPage({ reference }: { reference: string }) {
  const { data: run, isLoading } = useRun(reference, undefined, { refetchWhileRunning: true });

  useCrumbs([
    { label: "Solutions", to: "/solutions" },
    ...(run === undefined
      ? [{ label: reference }]
      : [
          { label: run.solution.name, to: `/solutions/${run.solution.slug}` },
          { label: `${run.planVersion.label} › run ${run.reference}` },
        ]),
  ]);

  if (isLoading) return <Skeleton className="h-96 w-full rounded-xl" />;

  const inProgress =
    run?.status === "running" || run?.status === "queued" || run?.status === "failed";
  return inProgress ? (
    <RunProgressView reference={reference} />
  ) : (
    <ScorecardView reference={reference} />
  );
}
